export default __webpack_public_path__ + "static/media/avatar-8.ad5418a9.jpg";